module.exports = __webpack_public_path__ + "static/how-to-3-0a607b1427c2982f40e5fb0054c98a8f.webp";